import { useState } from "react";
import TransactionDetailsV2 from "../TransactionDetailsV2";
import ReceiptTerminalsV2 from "../ReceiptTerminalsV2";
import SendReceiptV2 from "../SendReceiptV2";
import primaryComponents from "../../../primaryComponents";
import PrintOnDevice from "../PrintOnDevice";
import StoreCustomerForm from "../StoreCustomerForm";
import GenerateWaybillForm from "../GenerateWaybillForm";
import PrescriptionWidget from "../PrescriptionWidget";
import BillUpdate from "../BillUpdate";
import WaybillsDetails from "../WaybillsDetails";
import PrescriptionsDetails from "../PrescriptionsDetails";
import styles from "./styles.module.scss";
import { AngleLeft, CloseIcon } from "../../../../assets/svgIcons";
import { useNavigate, useSearchParams } from "react-router-dom";

const Orderflows = ({
  closeModal,
  orderId,
  defaultLanding = "tnxReceipt",
  viaSellMode = false,
  viaSaleRecord = false,
  isViaBill = false,
}) => {
  const [views, setViews] = useState({
    isTnxReceipt: defaultLanding === "tnxReceipt" || isViaBill ? true : false,
    isTerminal: false,
    isSendReceipt: false,
    isPrintOnDevice: false,
    isGeneratePescription: false,
    isGenerateWaybill: false,
    isPrescriptionDetails: false,
    isWaybillDetails: false,
    isOrderUpdate: false,
  });
  const [sectionId, setSectionId] = useState(null);
  const [billId, setBillId] = useState(null);
  const [viaPos, setViaPos] = useState(false);
  const [billWasUpdated, setBillWasUpdated] = useState(false);
  const navigate = useNavigate();
  const [search] = useSearchParams();

  const openView = (key) => {
    setViews((prev) => ({ ...prev, [key]: true }));
  };
  const closeView = (key) => {
    setViews((prev) => ({ ...prev, [key]: false }));
  };

  const resetView = (key) => {
    setViews({
      isTnxReceipt: false,
      isTerminal: false,
      isSendReceipt: false,
      isPrintOnDevice: false,
      isGeneratePescription: false,
      isGenerateWaybill: false,
      isStoreCustomerForm: false,
      [key]: true,
    });
  };

  return (
    <>
      <div className={styles.orderflow__header}>
        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
          {!views?.isTnxReceipt || search.get("prev") === "true" ? (
            <primaryComponents.Button
              classNames={"btn btn--outline"}
              // onClick={() => navigate(-1)}
              onClick={() => {
                if (views?.isTnxReceipt && search.get("prev") === "true")
                  return navigate(-1);
                if (views?.isTerminal) setSectionId(null);
                resetView("isTnxReceipt");
              }}
              style={{ width: "45px" }}
            >
              <AngleLeft className="dark--text" style={{ fontSize: "20px" }} />
            </primaryComponents.Button>
          ) : null}
          <h4 className="mb-0">Order Details</h4>
        </div>

        <primaryComponents.Button
          classNames={"ml-auto btn btn--outline"}
          onClick={closeModal}
          style={{ padding: "0 10px" }}
        >
          <CloseIcon className="mr-1 dark--text" style={{ fontSize: "20px" }} />
          Close
        </primaryComponents.Button>
      </div>

      <div className={styles.orderflow__body}>
        {views?.isTnxReceipt ? (
          <TransactionDetailsV2
            orderId={orderId}
            resetView={resetView}
            sectionId={sectionId}
            setViaPos={setViaPos}
            viaSellMode={viaSellMode}
            billWasUpdated={billWasUpdated}
            viaSaleRecord={viaSaleRecord}
          />
        ) : views?.isTerminal ? (
          <ReceiptTerminalsV2
            orderId={orderId}
            sectionId={sectionId}
            setSectionId={setSectionId}
          />
        ) : views?.isSendReceipt ? (
          <SendReceiptV2
            orderId={orderId}
            openView={openView}
            closeView={closeView}
          />
        ) : views?.isPrintOnDevice ? (
          <PrintOnDevice
            orderId={orderId}
            setSectionIdExternal={setSectionId}
            viaPos={viaPos}
            resetView={resetView}
            billWasUpdated={billWasUpdated}
          />
        ) : views?.isStoreCustomerForm ? (
          <StoreCustomerForm orderId={orderId} resetView={resetView} />
        ) : views?.isGenerateWaybill ? (
          <GenerateWaybillForm
            orderId={orderId}
            billId={billId}
            closeView={closeView}
          />
        ) : views?.isGeneratePescription ? (
          <PrescriptionWidget orderId={orderId} />
        ) : views?.isOrderUpdate ? (
          <BillUpdate
            orderId={orderId}
            resetView={resetView}
            setBillWasUpdated={setBillWasUpdated}
          />
        ) : views?.isWaybillDetails ? (
          <WaybillsDetails
            orderId={orderId}
            resetView={resetView}
            setBillId={setBillId}
          />
        ) : views?.isPrescriptionDetails ? (
          <PrescriptionsDetails orderId={orderId} />
        ) : null}
      </div>
    </>
  );
};
export default Orderflows;
